module.exports = __webpack_public_path__ + "img/stork_balance_card.b57c7f8e.svg";